<template>
  <div>
    <ContentsHeader>
      <template v-slot:title01>{{jobName}}</template>
      <template v-slot:explain01>
        食品を扱う小売店や、卸売店、飲食店などに自社の扱う製品を販売するのが食品メーカーの営業職です。食品を扱う仕入れ先の担当者へ提案をおこない、採用後もこまめな訪問から販売状況を分析し、販促企画等によって仕入先の売上に貢献していきます。仕入先の客層や売り場に応じて適切に自社製品が販売されるよう緻密な分析から販促イベントの取り仕切りまで一手に担当することが求められます。<br>
        食品流通の裏方から現場の販促まで関わるこの業界の営業職にはどんな特徴が見られるのでしょうか。
      </template>
      <template v-slot:yarigai01><span class="ddin">食材の調理方法や見せ方の提案をして顧客に喜んでもらえる</span><span class="ddin">(京都府 50歳 男性)</span></template>
      <template v-slot:yarigai02><span class="ddin">商品を消費者に広く届けることで、社会貢献を感じます</span><span class="ddin">(福岡県 41歳 女性)</span></template>
      <template v-slot:yarigai03><span class="ddin">商品について消費者が喜んでもらえた声を聞けること</span><span class="ddin">(奈良県 46歳 男性)</span></template>
      <template v-slot:img-headbg><img src="../assets/img/foodcompany/headbg.svg" :alt="jobName" class="img -foodcompany"></template>
      <template v-slot:img-headp><img src="../assets/img/foodcompany/person.svg" :alt="jobName" class="imgp -foodcompany"></template>
    </ContentsHeader>

    <div class="contents-block">

      <section class="job-section">
        <div class="jsinner">
          <div class="block-two -aistretch -jcsb -bptablet">
            <div class="block -b48p -p0">
              <BalanceChartSection :explain="bcExplain" :radarData="radarData"></BalanceChartSection>
            </div>
            <div class="block -b48p -p0">
              <JobChangeRateSection
                :explain="jcExplain"
                :doughnutData="doughnutData"
                :doughnutDataFake="doughnutData"
              ></JobChangeRateSection>
            </div><!-- .block -->
          </div><!-- .block-two -->
        </div><!-- .jsinner -->
      </section>

      <PersonalCharaSection :sevenData="sevenData" :secTtl="'食品メーカー業界'" >
        <template v-slot:feature>外向的で<br>大胆なパートナー</template>
        <template v-slot:imgpup><img src="../assets/img/foodcompany/person.svg" alt="食品メーカー業界の営業" class="imgcvperson -foodcampany"></template>
      </PersonalCharaSection>
    
      <div class="lb-area">
        <div class="lbinner block-two -bptablet">
          <div class="block">
            <CareerTypeSection :graphData="graphData" :explain="ctExplain" :jobName="'食品メーカー'"></CareerTypeSection>
          </div><!-- .block -->
          <div class=" block">
            <SalesTypeSection :graph2Data="graph2Data" :explain="stExplain" :jobName="'食品メーカー'"></SalesTypeSection>
          </div><!-- .block -->
        </div><!-- .block-two -->
      </div><!-- .lb-area -->

      <ResultSection :job="'foodcompany'">
        <template v-slot:jobname>食品メーカー業界の営業</template>
        <template v-slot:title01>対人能力の高い自信家</template>
        <template v-slot:explain01>
      どんな人にも興味を持ち、協力して物事を進める傾向が強いです。<br>
自信家ではありますがワンマンというわけではなく、周りとかかわりあいながら人の意見に合わせる友好的な面があり、流通から販売まで、どんな現場でもリーダーシップを発揮することに長けていることが読み取れます。
        </template>
        <template v-slot:title02>経験に基づいて大胆に行動</template>
        <template v-slot:explain02>
      大胆で感覚的な傾向にあることが読み取れます。ロジックよりも直感や自分の経験則に従い、思い切った判断をする面があります。<br>
売り場や顧客属性等のデータも業務で扱いながらも取引先の売上貢献のためにはダイナミックな販促支援を提案する傾向がありそうです。
        </template>
        <template v-slot:imgperson><img src="../assets/img/foodcompany/person.svg" alt="食品メーカー業界の営業" class="rsimg"></template>
      </ResultSection>

      <section class="other-section">
        <h2 class="osttl">その他の業界ごとの詳細をのぞく</h2>
        <div class="osinner">
          <DetailsList :job="'foodcompany'"></DetailsList>
        </div><!-- .osinner -->
      </section>

    </div><!-- contents-block -->
  </div>

</template>

<script>

import ContentsHeader from "../components/ContentsHeader.vue";
import ResultSection from "../components/ResultSection.vue";
import DetailsList from "../components/DetailsList.vue";

import BalanceChartSection from "../components/BalanceChartSection.vue";
import JobChangeRateSection from "../components/JobChangeRateSection.vue";
import PersonalCharaSection from "../components/PersonalCharaSection.vue";
import CareerTypeSection from "../components/CareerTypeSection.vue";
import SalesTypeSection from "../components/SalesTypeSection.vue";

export default {
  data() {
    return {
      pageTitle: "食品メーカーの営業をのぞく",
      pageURL: "foodcompany",
      pageDescription: "SALES SALES SCOPEでは不動産、保険、ITなど人気10業界の営業職に人物特性と成績に関する調査を実施。食品を扱う小売店や、卸売店、飲食店などに自社の扱う製品を販売するのが食品メーカーの営業職です。食品流通の裏方から現場の販促まで関わるこの業界の営業職にはどんな特徴が見られるのでしょうか。",

      jobName: "食品メーカーの営業",
      bcExplain: "計画性をのぞき全体的に高得点",
      jcExplain: "転職回数はやや多め",
      pcExplain: "外向的で大胆なパートナー",
      ctExplain: "世の中のために奉仕したい社会貢献タイプはやや少ない",
      stExplain: "提案を伝える方法を重視し、顧客と親密な関係を築こうとするタイプが多い",
      radarData: [7.81, 8.64, 7.49, 5.07, 8.63],
      doughnutData: [20, 24, 12, 28, 16],
      sevenData: [5, 3, 4, 5, 3, 2, 4],
      graphData: [
        { num: 1, val: 8 },
        { num: 2, val: 12 },
        { num: 3, val: 12 },
        { num: 4, val: 16 },
        { num: 5, val: 4 },
        { num: 6, val: 4 },
        { num: 7, val: 24 },
        { num: 8, val: 20 },
      ],
      graph2Data: [
        { num: 1, val: 12 },
        { num: 2, val: 28 },
        { num: 3, val: 24 },
        { num: 4, val: 28 },
        { num: 5, val: 8 },
      ],
    };
  },
  components: {
    BalanceChartSection,
    JobChangeRateSection,
    PersonalCharaSection,
    CareerTypeSection,
    SalesTypeSection,
    ContentsHeader,
    ResultSection,
    DetailsList    
  },
  metaInfo: {
    title: "食品メーカーの営業をのぞく | 営業職の特徴を人物特性からのぞいてみた",
    titleTemplate: "%s | SALES SCOPE",
    htmlAttrs: {
      lang: "jp",
    },
  },
  mounted: function(){
    // document.title = title;
    document.querySelector("meta[name='description']").setAttribute('content', this.pageDescription);
    document.querySelector("meta[property='og:title']").setAttribute('content', this.pageTitle + " | 営業職の特徴を人物特性からのぞいてみた | SALES SCOPE");
    document.querySelector("meta[property='og:description']").setAttribute('content', this.pageDescription);
    document.querySelector("meta[property='og:url']").setAttribute('content', 'https://sales-score.jp/scope/' + this.pageURL);
  }
};
</script>